import { createSlice } from '@reduxjs/toolkit';
export const STEPS_STATE_NAMESPACE = 'steps';
export var InsuranceStep;
(function (InsuranceStep) {
    InsuranceStep["flights"] = "flights";
    InsuranceStep["forms"] = "forms";
    InsuranceStep["details"] = "details";
})(InsuranceStep || (InsuranceStep = {}));
export const STEPS_WITH_PRICE = [
    InsuranceStep.forms,
    InsuranceStep.details,
];
export const stepsInitialState = {
    currentStep: InsuranceStep.flights,
};
const stepsSlice = createSlice({
    name: STEPS_STATE_NAMESPACE,
    initialState: stepsInitialState,
    reducers: {
        resetSteps: (state) => stepsInitialState,
        _setStep: (state, action) => {
            state.currentStep = action.payload;
        },
    },
});
export const { actions: stepsActions, reducer: stepsReducer } = stepsSlice;
